@if (type === 'project') {
  <div>
    @if (project) {
      <app-timelogs-form
        [editedProject]="project"
      ></app-timelogs-form>
    }
  </div>
} @else {
  @if (task) {
    <app-timelogs-form [editedTask]="task"></app-timelogs-form>
  }
}

